import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const NotificationContext = createContext();

const useNotification = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const timer = useRef(null);
  const [notification, setNotification] = useState({
    type: "",
    message: ""
  });
  const [visible, setVisible] = useState(false);

  const hideNotification = useCallback(() => {
    setNotification({ type: "", message: "" });
    setVisible(false);
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);

  const showNotification = useCallback((type, message) => {
    setNotification({ type, message });
    setVisible(true);
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      hideNotification();
      setNotification({ type: "", message: "" });
    }, 7000);
  }, [hideNotification]);



  return (
    <NotificationContext.Provider value={{ notification, visible, showNotification, hideNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export { useNotification, NotificationProvider };